import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { requestProposalSelectors } from '../store';
import type { OfferComment } from '../types';
import { toOfferComment } from '../utils/offerCommentUtils';

export const useOfferComment = (): OfferComment | undefined => {
    const { additionalSelectors } = requestProposalSelectors;
    const isOfferCommentsEnabled = useSelector(additionalSelectors.isOfferCommentsEnabled);
    const dealStructure = useSelector(additionalSelectors.getActiveDeal).dealStructure;
    const publishedVersionComment = useSelector(additionalSelectors.getPublishedVersionComment);
    const publisherName = useSelector(additionalSelectors.getPublishedBy);

    return useMemo(() => {
        if (!isOfferCommentsEnabled) return undefined;

        const versionComment = publishedVersionComment || dealStructure?.versionComment;
        return toOfferComment(versionComment, publisherName, dealStructure?.versionCreatedOn);
    }, [isOfferCommentsEnabled, dealStructure, publisherName, publishedVersionComment]);
};
